<template>
  <div id="ylQrcode">
    <qrCodeMobile
      v-if="isMobileScreen"
      v-bind="$attrs"
       />
    <ylQrCodePC
      v-else
      v-bind="$attrs"
       />
  </div>
</template>
<script>
export default {
  name: "ylQrcode",
  components: {
    qrCodeMobile: () => import("./components/mobile.vue"),
    ylQrCodePC: () => import("./components/pc.vue"),
  },
  data() {
    return {};
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {},
  methods: {},
};
</script>